var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-component',{ref:"search",staticClass:"fraud-notification",attrs:{"search-condition":_vm.searchCondition,"search-buttons":[{
                    type: 'download',
                    permissionCode: 'risk:fraud-notification:download',
                    func: _vm.onExportClick
                  }],"showMerchantSearch":true,"isDisplayReset":true,"router-name":"/risk/fraud-notification","fuzzySearchPlaceholder":_vm.fuzzySearchPlaceholder}})
}
var staticRenderFns = []

export { render, staticRenderFns }